import React from 'react';
import { Box, Center, Heading, Text, useColorModeValue, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { ArcButton } from '../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../common/components/SlidingAnimationPageBase';
import { COMPONENT_MIN_HEIGHT, TOP_NAV_SPACING_AFFORDANCE } from '../../common/constants';
import { CircleIcon, GridIcon } from '../../styles/custom-icons';
import { selectSite } from '../site/siteSlice';

export function TariffSetupComplete() {
  const site = useSelector(selectSite);
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const { t } = useTranslation();
  const paramBackURL = search.get('backURL');
  const backURL = `../home?direction=back`;

  const iconColor = useColorModeValue('primaryBranding.600', 'primaryBranding.200');

  const handleOnClick = async () => {
    if (site.isOnboarding) {
      navigate(`/sites/${site.site_id}/home`);
    } else {
      navigate(backURL);
    }
  };

  return (
    <SlidingAnimationPageBase
      title={t('Energy Rates.add your energy rates')}
      includeTopNav
      px={4}
      backURL={paramBackURL ?? backURL}
    >
      <VStack align={'initial'} h={`calc(${COMPONENT_MIN_HEIGHT} - ${TOP_NAV_SPACING_AFFORDANCE})`}>
        <Center position="relative" mb={1} flexDirection="column" textAlign="center">
          <Box w="80px" position={'absolute'}>
            <GridIcon w="100%" h="100%" color={iconColor} data-testid={`grid-icon`} />
          </Box>
          <CircleIcon h="60%" w="60%" color={iconColor} data-testid="circle-icon" zIndex={3} />
        </Center>
        <Heading textAlign="center" fontSize={24}>
          {t('Set Up Hardware.setup successful')}
        </Heading>
        <Text textAlign="center">{t('Energy Rates.tariff setup complete')}</Text>

        <Center mt="auto" mb={10} flexDir={'column'}>
          <ArcButton arcColor="#3DCD58" w="100%" py={6} mt="auto" data-testid="continue-btn" onClick={handleOnClick}>
            {t('Common.continue')}
          </ArcButton>
        </Center>
      </VStack>
    </SlidingAnimationPageBase>
  );
}
